import { formatCredits, formatCreditsWithWord, hasEnough } from '@/features/ai/lib/money'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  planSize: number
  /** Цена плана СЫРОЙ денежной строкой: её же сравниваем с балансом, поэтому
   *  показ наводится здесь, а не у вызывающего — иначе сравнивать было бы
   *  нечего, кроме уже отформатированной подписи. */
  cost: string | null
  /** Баланс автора из сметы. Без него блок цены просто молчит о балансе. */
  balance?: string
  /** Насколько план больше потолка прогона; 0 — уложились. */
  overBy: number
}

/** Подвал списка мест: сколько выбрано, во что обойдётся, хватает ли денег и
 *  не переполнен ли прогон. Вынесен из `TargetPicker` ради лимита строк. */
export const TargetPickerFooter = ({ planSize, cost, balance, overBy }: Props) => {
  // Предупредить о нехватке надо ДО платного клика: в авто-режиме это делает
  // `QuotePlate`, а в ручном цену считает сам список — сравнение живёт рядом с
  // ней. Считает его готовый `hasEnough` (деньги — строки, `Number` к ним не
  // применяем), второй арифметики здесь нет.
  const m = useMessages(messages)
  const notEnough = cost !== null && balance !== undefined && !hasEnough(balance, cost)
  return (
    <div className="space-y-1 border-t border-border pt-2 text-sm">
      <p>{m.selected(planSize)}</p>
      {cost ? (
        <p className="text-muted-foreground">
          {m.price(formatCreditsWithWord(cost))}
          {balance ? m.balance(formatCredits(balance)) : ''}
        </p>
      ) : null}
      {notEnough ? <p className="text-destructive">{m.notEnoughCredits}</p> : null}
      {overBy > 0 ? <p className="text-destructive">{m.overLimit(overBy)}</p> : null}
    </div>
  )
}
